import Select, { components } from 'react-select';

const ShipSelectBox = ({ shipList, ship, handleShipSelect }) => {
  const customStyles = {
    valueContainer: (provided) => ({
      ...provided,
      display: 'flex',
      flexWrap: 'nowrap',
    }),
  };

  const ValueContainer = ({ children, ...props }) => {
    const { selectProps } = props;
    const selectedCount = selectProps.value.length;

    if (selectedCount > 2) {
      return (
        <components.ValueContainer {...props}>
          {selectedCount} selected
        </components.ValueContainer>
      );
    } else if (
      Array.isArray(selectProps.value) &&
      selectedCount &&
      selectProps.value[0].value == ''
    ) {
      return (
        <components.ValueContainer {...props}>
          All selected
        </components.ValueContainer>
      );
    } else if (
      !Array.isArray(selectProps.value) &&
      selectProps.value.value == ''
    ) {
      return (
        <components.ValueContainer {...props}>
          All selected
        </components.ValueContainer>
      );
    }

    return (
      <components.ValueContainer {...props}>
        {children}
      </components.ValueContainer>
    );
  };

  return (
    <div>
      <label>Ship</label>
      <div className="select-box">
        <Select
          options={shipList}
          isMulti={true}
          value={ship}
          onChange={handleShipSelect}
          styles={customStyles}
          components={{ ValueContainer }}
          placeholder={'All Selected'}
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
        ></Select>
      </div>
    </div>
  );
};

export default ShipSelectBox;
